import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Route, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProviderListService } from 'src/app/dashboard/admin/report/services/gate-services/provider-list.service';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { BaseForm } from 'src/app/shared/product/baseForm';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { Validators } from 'src/app/shared/validators';
import {
  IMakeResponse,
  IModule,
  IProvider,
} from '../../models/fraud-interface';
import { FraudModuleCreateService } from '../../services/fraud/fraud-module-create.service';
import { FraudModuleEditService } from '../../services/fraud/fraud-module-edit.service';
import { FraudModuleGetService } from '../../services/fraud/fraud-module-get.service';

@Component({
  selector: 'app-manage-fraud-module',
  templateUrl: './manage-fraud-module.component.html',
  styleUrls: ['./manage-fraud-module.component.scss'],
})
export class ManageFraudModuleComponent extends BaseForm implements OnInit {
  id;
  isCreate = false;
  errorMessage;

  providers: Array<IProvider>;

  moduleForm: FormGroup;

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private activeRoute: ActivatedRoute,
    public formValidator: FormValidatorService,
    private translate: TranslateService,
    private moduleGet: FraudModuleGetService,
    private moduleUpdate: FraudModuleEditService,
    private createModule: FraudModuleCreateService,
    private providerListService: ProviderListService
  ) {
    super();
  }

  async ngOnInit() {
    try {
      this.initForm();

      this.activeRoute.paramMap.subscribe(async (paramMap: ParamMap) => {
        this.id = parseInt(paramMap.get('id'));
        if (this.id) {
          this.moduleGet.setParams({ id: this.id });
          let res: { module: IModule; success: boolean } =
            await this.moduleGet.make();
          const data = res.module;
          this.moduleForm.patchValue(data);
          this.cdr.detectChanges();
        } else {
          this.isCreate = true;
        }
      });
      await this.getProviders();
    } catch (err) {
      this.errorMessage = err.message;
    }
  }

  initForm() {
    this.moduleForm = this.formValidator.createForm([
      {
        fieldName: 'id',
        defaultValue: false,
      },
      {
        fieldName: 'name',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'public name',
            }),
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[a-z ]+$)/i),
            message: this.translate.instant('FormValidation.TextOnly', {
              field: 'merchant_name',
            }),
          },
        ],
      },
      {
        fieldName: 'provider',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'provider',
            }),
          },
        ],
      },
      {
        fieldName: 'active',
        defaultValue: false,
      },
    ]);
  }

  async getProviders() {

    let result = await this.providerListService.getProviders();
    this.providers = result.providers;
  }

  get formsValidation() {
    return !this.moduleForm.valid;
  }

  async save() {
    let result: IMakeResponse;
    if (!this.isCreate) {
      this.moduleUpdate.setParams({ module: this.moduleForm.value });
      result = await this.moduleUpdate.make();
    } else {
      this.createModule.setParams({ ...this.moduleForm.value });
      result = await this.createModule.make();
    }
    if (result.success) this.router.navigate(['admin/fraud/module']);
    else this.errorMessage = result.message;
  }
}
